import script from "./PropertyMapTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropertyMapTab.vue?vue&type=script&setup=true&lang=ts"

import "./PropertyMapTab.vue?vue&type=style&index=0&id=593d79ee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593d79ee"]])

export default __exports__